import React from "react";
import ErrorPage from "./index";

export default function NotFound() {
  return (
    <ErrorPage
      title="Oh no! We can't find the page that you are looking for."
      errorCode="HTTP ERROR 404"
      infoText="Check that the URL is correct, or head back and try again."
    />
  );
}
